import { Injectable } from '@angular/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()

export class ProposalDiagnosisService {
    constructor(public secureApi: SecureApi) { }

    getSelectedDiagnosis(questionnaireId) {
        return this.secureApi.get('patient-questionnaire/proposal-diagnosis/'+ questionnaireId);
    }

    updateProposalDiagnosis(params, patientId) {
        return this.secureApi.post('patient/proposal-diagnosis/'+ patientId, params, false);
    }

    updateRating(data) {
        return this.secureApi.post(`patient-questionnaire/diagnosis-interview/symptoms/${data.patient_questionnaire_id}/${data.domain_id}/${data.isAcute}`, data, false);
    }

    updatePrimary(data) {
        return this.secureApi.post(`patient-questionnaire/diagnosis-interview/feeling-primary/${data.patient_questionnaire_id}`, data, false);
    }

    updateStatus(data) {
        return this.secureApi.post(`patient-questionnaire/proposal-diagnosis/update-status`, data, false);
    }

    reviewProposal(data) {
        return this.secureApi.post(`patient-questionnaire/proposal-diagnosis/update-proposal-status`, data, false);
    }
}
